/**
 * Scroll helpers
 * @module lib/scroll
 */

/**
 * Prevent scroll updates around the run of given function
 *
 * Note: This only work if fn is synchronous.
 * @param {Function} fn
 */
export function whileMaintainingScroll(fn) {
  const currentScrollY = window.pageYOffset;
  const currentScrollX = window.pageXOffset;
  fn();
  window.scrollTo(currentScrollX, currentScrollY);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/scroll.js